export default "__VITE_ASSET__0c520ebd__"